import { BaseViewModel } from "../../system/systemOverview/SystemOverview.types.ts";

export interface InputFieldRow {
    id: string;
    name: string;
    description?: string;
    type: InputFieldTypeEnum;
    entityTemplates: Array<BaseViewModel>;
}

export interface InputFieldRowTableModel extends InputFieldRow {
    entityTemplatesString: string;
    typeString: string;
}

export interface StandardInputFieldRow {
    name: string;
}

export interface InputField {
    id: string;
    customerId: string;
    name: string;
    type: InputFieldTypeEnum;
    configuration?: InputFieldConfiguration;
    isConfigurableField: boolean;
}

export interface InputFieldSelectOption {
    id: string;
    name: string;
}

export interface InputFieldConfiguration {
    currencyCode?: string;
    list: InputFieldSelectOption[];
}

export enum InputFieldTypeEnum {
    TextField = 1,
    RichTextField = 2,
    SingleDropDown = 3,
    MultiDropDown = 4,
    DateField = 5,
    NumberField = 6,
    AmountField = 7,
    CheckboxField = 8,
    LegalEntityField = 9,
    UserField = 10,
    CalculatedField = 11,
    CountryField = 12,
    DatePeriodField = 13,
}
